import classNames from 'classnames';
import React, { FC } from 'react';
import IOffset from '../../interfaces/IOffset';
import stylesGrid from "../../style/Grid.module.scss";

interface ColProps {
    className?: string;
    width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    offset?: IOffset;
    marginBottom?: IOffset;
    children: any;
}

const Col : FC<ColProps> = ({
    className, 
    width,
    offset,
    marginBottom,
    children,
}) => {

    return(
        <div className={classNames(
            stylesGrid.Col,
            width && stylesGrid[`col${width}`],
            offset && stylesGrid[`offset__${offset}`],
            marginBottom && stylesGrid[`marginBottom__${marginBottom}`],

            className && className
        )}
        >
            {children}
        </div>
    );
}
export default Col;